import React from 'react'
import { IconButton } from '~/components/IconButton'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'

interface DownloadButtonProps {
  onClick: () => void
  variant?: 'transparent' | 'just-icon'
}

export function DownloadButton({ onClick, variant }: DownloadButtonProps) {
  return (
    <IconButton
      icon={<ArrowDownTrayIcon />}
      screenReaderText="Download captured meeting"
      tooltip="Download captured meeting"
      onClick={onClick}
      variant={variant}
    />
  )
}
